import Component from 'Component/Component';
import dragonBones from 'pixi-dragonbones';
import { FarmEnvironmentEffect } from 'System/Farm/FarmEffect';
import { ILimit } from 'Utility/MathHelper';

type PixiArmatureDisplay = dragonBones.PixiArmatureDisplay;

export default class FarmEffectComponent extends Component<
    PixiArmatureDisplay,
    FarmEnvironmentEffect
> {
    public x: number = 0;
    public y: number = 0;
    public xOffsetRange: ILimit | ILimit[] = undefined;
    public yOffsetRange: ILimit | ILimit[] = undefined;
    public intervalRange: ILimit | ILimit[] = undefined;
    public animationNames: string[] = [];  
}
